module.exports = __webpack_public_path__ + "static/TNDbg-77320eb45be86777f2d2a26d6ac16179.jpg";